import { render, staticRenderFns } from "./ReportFormPersonalDataAlt.vue?vue&type=template&id=15312b33"
import script from "./ReportFormPersonalDataAlt.vue?vue&type=script&lang=ts"
export * from "./ReportFormPersonalDataAlt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports